import './style.scss'

import TableTeamsInvite from 'components/molecules/TableTeamsInvite'
import { TeamSideId } from 'features/team/const'
import { teamHooks } from 'features/team/index.ts'
import { Navigate } from 'react-router-dom'
import { leftSideHooks } from 'shared/hooks'

import { useLegacyPersonas } from '../useLegacyPersonas'

export function InvitedPage() {
	const showMembers = teamHooks.useIsEnable()
	const hasInvited = teamHooks.useHasInvited()

	const [personas, { isSuccess, refetch }] = useLegacyPersonas()

	leftSideHooks.useActive(TeamSideId.Invites)
	const noInviteMembers = isSuccess && !hasInvited

	if (!showMembers || noInviteMembers) {
		return <Navigate to='/team/members' />
	}

	return <TableTeamsInvite getPersonas={refetch} personas={personas} />
}
